import { render, staticRenderFns } from "./EditorTemplate.vue?vue&type=template&id=385bba8f"
import script from "./EditorTemplate.vue?vue&type=script&lang=ts"
export * from "./EditorTemplate.vue?vue&type=script&lang=ts"
import style0 from "./EditorTemplate.vue?vue&type=style&index=0&id=385bba8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports